import { render, staticRenderFns } from "./ReportMaterialsTable.vue?vue&type=template&id=82bdee7a&"
import script from "./ReportMaterialsTable.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports